import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import Decimal from 'decimal.js';
import * as moment from 'moment';
import { MenuItem } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { forkJoin } from 'rxjs';
import { ApiError } from 'src/app/api-error';
import { GeneralSupplierUnpaidInvoiceForm } from 'src/app/form-template/general-supplier-unpaid-invoice-form';
import { GeneralSupplier } from 'src/app/general-supplier';
import { GeneralSupplierPaymentType } from 'src/app/general-supplier-payment-type';
import { GeneralSupplierUnpaidInvoice } from 'src/app/general-supplier-unpaid-invoice';
import { HttpService } from 'src/app/service/http.service';
import { UserService } from 'src/app/service/user.service';
import { ToastMessageService } from 'src/app/toast-message.service';

@Component({
  selector: 'app-edit-unpaid-invoice',
  templateUrl: './edit-unpaid-invoice.component.html',
  styleUrl: './edit-unpaid-invoice.component.css'
})
export class EditUnpaidInvoiceComponent {

  suppliers: GeneralSupplier[] = [];
  paymentTypes: GeneralSupplierPaymentType[] = [];
  selectedFile: File | null = null;
  @ViewChild("fileUploader") fileUploader: FileUpload | null = null;
  invoiceForm: FormGroup<GeneralSupplierUnpaidInvoiceForm>;

  isSupplierDialogVisible: boolean = false;
  supplierForm: FormGroup;

  isCreatingInvoice = false;
  isInvoiceValidator: boolean = false;
  selectedInvoice: GeneralSupplierUnpaidInvoice | null = null;
  canAddInvoice: boolean = false;

  topMenuItems: MenuItem[] = [];

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private route: ActivatedRoute,
    private toastService: ToastMessageService,
    private userService: UserService
  ) {
    if(userService.isNot("accountant")){
      this.canAddInvoice = true;
    }
    this.topMenuItems = [
      { label: "Invoices", routerLink: ["/management/general-supplier-invoice/invoices"] },
      { label: "Unpaid invoices", routerLink: ["/management/general-supplier-invoice/unpaid-invoices"], visible: this.canAddInvoice},
      { label: "Add paid invoice", routerLink: ["/management/general-supplier-invoice/create-paid-invoice"], visible: this.canAddInvoice},
      { label: "Add invoice to be paid", routerLink: ["/management/general-supplier-invoice/create-unpaid-invoice"], visible: this.canAddInvoice}
    ];
    this.isInvoiceValidator = userService.hasAnyRole(["superadmin", "general_invoice_validator"]);
    let selectedInvoiceId = route.snapshot.paramMap.get("invoiceId");
    forkJoin([
      this.httpService.getGeneralSuppliers(),
      this.httpService.getGeneralSupplierPaymentTypes(),
      this.httpService.getGeneralSupplierUnpaidInvoicesById(Number(selectedInvoiceId))
    ]).subscribe({
      next: ([suppliers, paymentTypes, invoice]) => {
        this.suppliers = suppliers;
        this.paymentTypes = paymentTypes;
        this.selectedInvoice = invoice;
        this.invoiceForm.controls.amount.setValue(invoice.amount.toNumber());
        this.invoiceForm.controls.invoiceNumber.setValue(invoice.invoiceNumber);
        this.invoiceForm.controls.date.setValue(invoice.date.toDate());
        this.invoiceForm.controls.supplier.setValue(invoice.supplier);
        this.invoiceForm.controls.paymentType.setValue(invoice.type);
        this.invoiceForm.controls.comment.setValue(invoice.comment);
        this.invoiceForm.controls.isValidated.setValue(invoice.isValidated);
      },
      error: (err) => {
        let error = new ApiError(err);
        toastService.addApiError(error);
      }
    });

    this.invoiceForm = builder.group<GeneralSupplierUnpaidInvoiceForm>({
      supplier: new FormControl(),
      amount: new FormControl(),
      date: new FormControl(),
      file: null,
      comment: new FormControl(),
      paymentType: new FormControl(null),
      isValidated: new FormControl(this.isInvoiceValidator ? true : false),
      invoiceNumber: new FormControl(null)
    });
    this.supplierForm = builder.group({
      name: new FormControl<string | null>(null, Validators.required)
    });
    this.invoiceForm.controls.supplier.disable();
  }

  //update informations
  submit() { 
    if(this.invoiceForm.value.amount && typeof this.invoiceForm.value.amount === 'number'){
      this.selectedInvoice!.amount = new Decimal(this.invoiceForm.value.amount);
    }
    if(this.invoiceForm.controls.date.value){
      this.selectedInvoice!.date = moment(this.invoiceForm.controls.date.value).utc(true);
    }
    if(this.invoiceForm.value.invoiceNumber && this.invoiceForm.value.invoiceNumber!.length > 0){
      this.selectedInvoice!.invoiceNumber = this.invoiceForm.value.invoiceNumber!.trim();
    }
    if(this.invoiceForm.value.comment && this.invoiceForm.value.comment.length > 0){
      this.selectedInvoice!.comment = this.invoiceForm.value.comment.trim();
    }
    this.httpService.updateGeneralSupplierUnpaidInvoice(this.selectedInvoice!).subscribe(() => {
      this.toastService.addSuccess("Success", "Invoice information updated");
    }, error => {
      let apiErr = new ApiError(error);
      this.toastService.addApiError(apiErr);
    });
  }

  submitSupplier() { }

  activateSupplierDialog() { }

  onFileSelect(files: File[]) {
    if (files.length > 0) {
      this.selectedFile = files[0];
    }
  }
  clearSelectedFile() {
    this.fileUploader?.clear();
    this.selectedFile = null;
  }

  updateValidationStatus(checked: boolean){
    this.httpService.updateGeneralSupplierUnpaidInvoiceValidationStatus(this.selectedInvoice?.id!, this.invoiceForm.value.isValidated!).subscribe(() => {
      this.toastService.addSuccess("Success", "Validation status updated");
    }, error => {
      let apiError = new ApiError(error);
      this.toastService.addApiError(apiError);
    });
  }
}